export default __webpack_public_path__ + "static/media/background.6f8b15e3.png";